$(function () {

    function getSortData(options) {
        var defaultOptions = {
            sort: null,
            container: null,
            sortType: 'asc',
            id: null,
            type: null,
            field: 'views',
            self: null,
            page: 1
        };

        options = $.extend(defaultOptions, options);

        $.ajax({
            url: '/appearance/data',
            type: 'POST',
            dataType: 'json',
            data: {
                sort: options.sortType,
                id: options.id,
                type: options.type,
                field: options.field,
                container: options.container,
                page: options.page
            },
            success: function (response) {
                if(response.status === 'success'){
                    $(options.container).html(response.html);
                    if(options.sort !== null) {
                        options.sort.find('.sort-item').each(function () {
                            $(this).removeClass('sort-item-asc');
                            $(this).removeClass('sort-item-desc');
                        });
                        if(options.self !== null) {
                            options.self.addClass('sort-item-' + options.sortType);
                        }
                    }
                }
            },
            error: function () {
                swal('Error', 'An error occurred. Please try again later.', 'error');
            },
            complete: function () {
                $('.sort-overlay').hide();
                $('.appearance-sort-overlay').hide();
            }
        });
    }

    $(document).on('click', '.sort-item', function (e) {
        var self = $(this);
        var sort = $(this).parents('.appearance-sort');
        var id = sort.data('id');
        var type = sort.data('type');
        var container = sort.data('container');
        var sortType = 'asc';
        var field = $(this).data('field');

        var defaultSort = $(this).data('defaultSort') || 'desc';

        $('.appearance-sort-overlay').show();

        if(self.hasClass('sort-item-desc')){
            /*self.removeClass('sort-item-desc');
            self.addClass('sort-item-asc');*/
            sortType = 'asc';
        } else if(self.hasClass('sort-item-asc')){
            /*self.removeClass('sort-item-asc');
            self.addClass('sort-item-desc');*/
            sortType = 'desc';
        } else {
            sortType = defaultSort;
        }

        getSortData({
            sort: sort,
            container: container,
            sortType: sortType,
            id: id,
            type: type,
            field: field,
            self: self
        });
    });

    $(document).on('click', '.action-next-page', function (e) {
        var self = $(this);
        var page = self.data('page');
        var sortType = self.data('sort');
        var field = self.data('field');
        var type = self.data('type');
        var id = self.data('id');
        var container = self.data('container');


        getSortData({
            container: container,
            sortType: sortType,
            id: id,
            type: type,
            field: field,
            page: page
        });
    });


});
